import { render, staticRenderFns } from "./AcoesEnviosRemessa.vue?vue&type=template&id=03c02b7a&scoped=true"
import script from "./AcoesEnviosRemessa.vue?vue&type=script&lang=js"
export * from "./AcoesEnviosRemessa.vue?vue&type=script&lang=js"
import style0 from "./AcoesEnviosRemessa.vue?vue&type=style&index=0&id=03c02b7a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c02b7a",
  null
  
)

export default component.exports